import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import SummaryZonesPieCard from './SummaryZones';
import { MainCard } from 'component/cards/MainCard2';

const timeToSeconds = (timeStr) => {
    const [hours, minutes, seconds] = timeStr.split(':').map(Number);
    return hours * 3600 + minutes * 60 + seconds;
};

const formatDuration = (seconds) => {
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return `${min}:${sec.toString().padStart(2, '0')} min`;
};

const HrTimeline = ({ hrPoints, trainingHr, minTrainHr, summaryZones }) => {
    if (!hrPoints || !hrPoints.length) return null;

    const startSec = timeToSeconds(hrPoints[0].time);
    const endSec = timeToSeconds(hrPoints[hrPoints.length - 1].time);
    const totalDuration = endSec - startSec || 1;

    const timestamps = [
        0,
        Math.round(totalDuration * 0.25),
        Math.round(totalDuration * 0.5),
        Math.round(totalDuration * 0.75),
        totalDuration
    ];

    return (
        <MainCard title={t('records.charts.hrZones')} sx={{ width: '100%' }}>
            {/* Timeline */}
            <Box sx={{ width: '100%', mt: 2 }}>
                <Box
                    sx={{
                        display: 'flex',
                        width: '100%',
                        height: 24,
                        borderRadius: 4,
                        overflow: 'hidden'
                    }}
                >
                    {hrPoints.map((point, index) => {
                        const currentSec = timeToSeconds(point.time);
                        const nextSec = hrPoints[index + 1]
                            ? timeToSeconds(hrPoints[index + 1].time)
                            : endSec;
                        const widthPercent =
                            ((nextSec - currentSec) / totalDuration) * 100;

                        let color = '#2c9e00';
                        if (point.hr >= minTrainHr && point.hr < trainingHr)
                            color = '#e6c72e';
                        else if (point.hr >= trainingHr) color = '#f44336';

                        return (
                            <Box
                                key={index}
                                sx={{
                                    width: `${widthPercent}%`,
                                    backgroundColor: color
                                }}
                            />
                        );
                    })}
                </Box>

                {/* Timestamps */}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        mt: 1,
                        fontSize: 12,
                        color: '#555'
                    }}
                >
                    {timestamps.map((t, i) => (
                        <span key={i}>{formatDuration(t)}</span>
                    ))}
                </Box>

                {/* Summary */}
                <Box sx={{ mt: 2 }}>
                    <SummaryZonesPieCard summaryZones={summaryZones} />
                </Box>
            </Box>
        </MainCard>
    );
};

HrTimeline.propTypes = {
    hrPoints: PropTypes.arrayOf(
        PropTypes.shape({
            time: PropTypes.string.isRequired,
            hr: PropTypes.number.isRequired
        })
    ).isRequired,
    trainingHr: PropTypes.number.isRequired,
    minTrainHr: PropTypes.number.isRequired,
    summaryZones: PropTypes.array.isRequired
};

export default HrTimeline;
